exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n#expiration[data-v-362c6d0a] {\n  margin-bottom: 10px;\n}\n", "", {"version":3,"sources":["/home/runner/work/online-store/online-store/src/components/checkout/payment/CreditCardExpiration.vue"],"names":[],"mappings":";AAAA;EACE,oBAAoB;CAAE","file":"CreditCardExpiration.vue","sourcesContent":["#expiration {\n  margin-bottom: 10px; }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?sourceMap!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-362c6d0a","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/checkout/payment/CreditCardExpiration.vue
// module id = iczn
// module chunks = 18